/**
 * @namespace Utils
 * @aka PIANO.Utils
 *
 */
PIANO.Utils = function (window, document) {

  var elementIdPiano = document.querySelector('script#piano');

  /**
   *
   * @type {*|(function(): string|string)}
   */
  window.getOptOuts = window.getOptOuts || function () {
    var parts = ('; ' + document.cookie).split('; tracking_optout=');
    return 2 === parts.length ? parts.pop().split(';').shift() : ''
  };

  /**
   *
   * @param {string} name
   * @param {?*} [detail]
   */
  function triggerEvent(name, detail) {

    var options = {
      bubbles: true,
      cancelable: false
    }

    if (null !== detail) {
      options.detail = detail;
    }

    // create a  event that bubbles up and can be canceled
    var event = new CustomEvent('piano:' + name, options);

    // Emit the event
    document.dispatchEvent(event);
  }

  /**
   * Überwachen von `#content` um Änderungen am `pjax.container` zu überwachen, entspricht somit `pjax:end`
   *
   */
  (function () {
    var isBeforeReplaceFired = false;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (2 <= mutation.removedNodes.length) {
          console.debug('Tracking Piano Utils: `beforeReplace` fired');
          isBeforeReplaceFired = true;
          triggerEvent('beforeReplace');
        }

        if (!isBeforeReplaceFired) {
          return;
        }

        if (2 > mutation.addedNodes.length) {
          return;
        }

        console.debug('Tracking Piano Utils: `pushstate` fired')
        isBeforeReplaceFired = false;
        triggerEvent('pushstate');
      });
    });

    var elementContainer = document.querySelector('#content');
    if (elementContainer) {
      // observe everything except attributes
      observer.observe(elementContainer, {
        childList: true,
        subtree: false
      });
    }
  })();

  /**
   *
   */
  (function () {

    var report = function (event) {
      if (!event || 'beforeunload' !== event.type) {
        return;
      }
      if (window.unloaded) {
        return;
      }

      console.debug('Tracking Piano Utils', 'beforeunload');
      triggerEvent('beforeunload');

      window.unloaded = true;

      /* Remove the listeners from the window */
      window.removeEventListener('beforeunload', report);
    };

    window.addEventListener('beforeunload', report);
  })();

  /**
   *
   */
  (function () {
    var report = function (event) {
      event.preventDefault();

      console.debug('Tracking Piano Utils', 'pagehide');

      triggerEvent('pagehide');
    };

    window.addEventListener('pagehide', report)
  })();

  /**
   *
   */
  (function () {

    var report = function (event) {
      if (!event || 'visibilitychange' !== event.type) {
        return
      }

      /* If the user changes the tab or minimizes the browser, set the tab as unloaded */
      if ('hidden' === document.visibilityState && !window.unloaded) {
        window.unloaded = true;
        console.debug('Tracking Piano Utils', 'visibility change hidden');
      }

      /* If the user changes back to the tab, set the tab as loaded */
      if ('visible' === document.visibilityState && window.unloaded) {
        window.unloaded = false;
        console.debug('Tracking Piano Utils', 'visibility change visible');

        /* If the user has been on the page for more than 30 minutes, push a new pageview event */
        if ((Date.now() - window.startTime) / 1000 > 1800) {
          triggerEvent('pageview');

          window.startTime = Date.now();
        }
      }
    };

    window.addEventListener('visibilitychange', report);
  })();

  document.addEventListener('piano:pushstate', function () {
    /**
     *
     * @type {?HTMLElement}
     */
    elementIdPiano = document.querySelector('script#piano');
    if (null === elementIdPiano) {
      console.error('Tracking Piano Utils', 'keine Seiteninformationen vorhanden')
      return;
    }

    console.debug('Tracking Piano Utils', 'Seiteninformationen', elementIdPiano.dataset)
  })

  /**
   * ------------------------------------------------------------------------
   * Private Helpers
   * ------------------------------------------------------------------------
   */

  var getCanonical = function getCanonical() {
    var canonical = '';
    var links = document.querySelectorAll('link[rel="canonical"]')
    for (var i = 0; i < links.length; i++) {
      if (links[i].hasAttribute('href')) {
        canonical = links[i].getAttribute('href')
      }
    }
    return canonical;
  }

  /**
   *
   * @param {string} key
   * @param {*} [defaultValue] undefined
   * @param {boolean} [json] false
   * @return {*}
   */
  function getPageInformation(key, defaultValue, json) {
    if (json !== true) {
      json = false;
    }

    if (undefined === elementIdPiano.dataset[key]) {
      return defaultValue;
    }

    var value = elementIdPiano.dataset[key];
    if (json) {
      try {
        value = JSON.parse(value);
      } catch (exception) {
        (console.error || console.log).call(console, exception.stack || exception)
        return defaultValue;
      }
    }

    return value;
  }

  /**
   *
   * @return {boolean}
   */
  var isEnabled = function isEnabled() {
    if ('undefined' !== typeof window.getOptOuts && -1 !== window.getOptOuts().indexOf('atInternet')) {
      console.debug('Tracking Piano Pageview', 'optout Flag gesetzt');
      return false;
    }

    if (null === elementIdPiano) {
      if(!window.isFractal) {
        console.error('Tracking Piano Pageview', 'Element `#piano` nicht definiert');
      }
      return false;
    }

    if ('undefined' === typeof window._pac) {
      console.error('Tracking Piano Pageview', 'Konfiguration `_pac` nicht definiert');
      return false;
    }

    if ('undefined' === typeof window._paq) {
      console.error('Tracking Piano Pageview', 'Queue `_paq` nicht definiert');
      return false;
    }

    window._paq.push(['setConfiguration', 'enableAutomaticPageRefresh', true]);
    window._paq.push(['setConfiguration', 'campaignPrefix', ['at_', 'utm_']]);

    /* SOS-34044 */
    var collectDomainHosts = [
      'beta2.swrfernsehen.de',
      'beta2.swr.de',
      'www.swrfernsehen.de',
      'www.swr.de'
    ];
    if (-1 !== collectDomainHosts.indexOf(window.location.hostname.toLowerCase())) {
      window._paq.push(['setConfiguration', 'collectDomain', 'https://pa.swr.de']);
    }
    /* End SOS-34044 */

    /*
     * Solange ATI aktiv ist kann PIANO nicht genutzt werden
     */
    if ('undefined' !== typeof window.ATInternet && 'undefined' !== typeof window.ATInternet.Tracker) {
      console.debug('Tracking Piano Pageview', 'ATI Smarttag noch aktiv');
      return false;
    }

    return true;
  }

  /**
   * --------------------------------------------------------------------------
   * Public Utils Api
   * --------------------------------------------------------------------------
   */
  return {
    getCanonical: getCanonical,
    getPageInformation: getPageInformation,
    isEnabled: isEnabled,
    trigger: triggerEvent
  };

}(window, document);
